var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-content content auth-page"},[_c('div',{staticClass:"content-wrapper",staticStyle:{"padding":"0 !important"}},[_c('router-view')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }